import { UserPlus, DollarSign, Trophy, Wrench } from "lucide-react";

// Dark partnership-benefits section inspired by the "Benefits of partnering with Rightworks"
// reference — rebranded to Vittaniti and remapped to navy + gold.
const BENEFITS = [
    {
        icon: UserPlus,
        title: "Enhance customer value",
        body: "Partnering with Vittaniti increases revenue, enhances the customer experience, improves productivity and continues to cement your position as a trusted provider.",
    },
    {
        icon: DollarSign,
        title: "Expand revenue sources",
        body: "With the support of the Vittaniti team, you can spin up new service offerings quickly — opening the door to new customers and adjacent verticals.",
    },
    {
        icon: Trophy,
        title: "Create a win-win opportunity",
        body: "Achieve lucrative rewards for the customers you bring to us, and save money for them through your referral. As your business grows with us, so will your rewards.",
    },
    {
        icon: Wrench,
        title: "Support tools to ensure success",
        body: "Vittaniti makes sure your partnership is successful. Get access to compelling content — success stories, eBooks, guides, research, email templates and more.",
    },
];

export default function PartnerBenefitsDark() {
    return (
        <section className="relative isolate" data-testid="partner-benefits-dark">
            <div className="absolute inset-0 -z-10" style={{ backgroundColor: "#0F1B2E" }} />
            <div className="container-page py-20 md:py-28">
                <div className="max-w-3xl mx-auto text-center mb-14">
                    <p className="overline text-brand-amber mb-3">Partner benefits</p>
                    <h2 className="display text-4xl md:text-5xl lg:text-6xl text-white leading-[1.05]">
                        The benefits of partnering with Vittaniti.
                    </h2>
                </div>

                <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-px bg-white/8 rounded-2xl overflow-hidden border border-white/10">
                    {BENEFITS.map((b, i) => {
                        const Icon = b.icon;
                        return (
                            <article
                                key={b.title}
                                data-testid={`dark-partner-${i}`}
                                className="p-8 md:p-9 flex flex-col animate-fade-up"
                                style={{ animationDelay: `${i * 80}ms`, backgroundColor: "#0F1B2E" }}
                            >
                                <span
                                    className="grid place-items-center w-14 h-14 rounded-xl mb-7"
                                    style={{
                                        backgroundColor: "rgba(229,182,86,0.10)",
                                        border: "1px solid rgba(229,182,86,0.35)",
                                    }}
                                >
                                    <Icon size={24} strokeWidth={1.5} className="text-brand-amber" />
                                </span>
                                <h3 className="font-serif text-2xl text-white leading-tight mb-3">
                                    {b.title}
                                </h3>
                                <p className="text-sm text-white/65 leading-relaxed">{b.body}</p>
                            </article>
                        );
                    })}
                </div>
            </div>
        </section>
    );
}
